import React, { useContext, useEffect, useState } from "react";
import { FilterContext } from "../../context/Filter";
import { fetchcustdetail } from "./Newpvinkpi";

const SubscriptionDetails = () => {
  const { superArn: parArn } = useContext(FilterContext);

  const [subscriptionData, setSubscriptionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Dynamically determine ARN
  const getDynamicArn = () => {
    // if (childArn) return { key: "childArn", value: childArn };
    if (parArn) return { key: "parArn", value: parArn };

    const urlParams = new URLSearchParams(window.location.search);
    const vin = urlParams.get("vin");
    if (vin) return { key: "parArn", value: vin };

    return { key: null, value: null };
  };

  const { key, value } = getDynamicArn();
  const payload = value ? { [key]: value } : null;

  const fetchSubscriptionDetails = async () => {
    if (!value) return;

    setLoading(true);
    setError(null);
    try {
      const response = await fetchcustdetail(payload);
      setSubscriptionData(response?.ls_subs || []);
    } catch (err) {
      console.error("Error fetching subscription details:", err);
      setError("no data");
      setSubscriptionData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionDetails();
  }, [value, parArn]); // re-fetch if ARN or VIN changes

  const planCounts = subscriptionData.reduce(
    (acc, item) => ({
      ...acc,
      [item.Plan]: item["VehicleId Count"],
    }),
    {}
  );

  return (
    <div className="border rounded-md w-[331px] p-2">
      <p className="font-semibold mb-2">Subscription Detail</p>

      {loading ? (
        <div className="flex justify-center items-center h-[100px]">
          <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          <span className="ml-2 text-sm text-gray-600">Loading...</span>
        </div>
      ) : error ? (
        <p className="text-red-500 text-center">{error}</p>
      ) : subscriptionData.length === 0 ? (
        <p className="text-center text-gray-500 text-sm">No data available</p>
      ) : (
        <div className="flex flex-col gap-2">
          <div className="bg-[#1467b3] flex justify-between items-center text-white p-1 w-full">
            <p className="text-center flex-1">Standard</p>
            <p className="text-center flex-1">Advance</p>
            <p className="text-center flex-1">Upgrade</p>
            <p className="text-center flex-1">Expired</p>
          </div>
          <div className="flex justify-between items-center p-1 w-full">
            <p className="text-center flex-1">{planCounts.Standard || 0}</p>
            <p className="text-center flex-1">{planCounts.Advance || 0}</p>
            <p className="text-center flex-1">{planCounts.Upgrade || 0}</p>
            <p className="text-center flex-1">{planCounts.Expired || 0}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionDetails;
